// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DollarSquareIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "DollarSquare/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.375 6.733v2.384l-.842-.292c-.425-.15-.683-.292-.683-1.017 0-.591.442-1.075.983-1.075h.542ZM12.15 12.192c0 .591-.442 1.075-.983 1.075h-.542v-2.384l.842.292c.425.15.683.292.683 1.017Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.984c0 3.033 1.808 4.841 4.841 4.841h6.984c3.033 0 4.841-1.808 4.841-4.841V6.508c0-3.033-1.808-4.841-4.841-4.841ZM11.883 10c.65.225 1.517.7 1.517 2.192 0 1.283-1 2.325-2.233 2.325h-.542V15a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625v-.483h-.3c-1.367 0-2.475-1.159-2.475-2.575a.624.624 0 1 1 1.25 0c0 .733.55 1.325 1.225 1.325h.3v-2.825L8.117 10C7.467 9.775 6.6 9.3 6.6 7.808c0-1.283 1-2.325 2.233-2.325h.542V5A.63.63 0 0 1 10 4.375a.63.63 0 0 1 .625.625v.483h.3c1.367 0 2.475 1.159 2.475 2.575a.624.624 0 1 1-1.25 0c0-.733-.55-1.325-1.225-1.325h-.3v2.825l1.258.442Z"
}));
export default DollarSquareIcon;